"use strict";
import isMobile from "./modules/isMobile.js";

// SP メニュー項目開閉
$(".js-menu").on("click", (event) => {
  const target = $(event.currentTarget);
  const targetMenulist = $(event.currentTarget).find(".menu-list");

  if (target.hasClass("active")) {
    target.removeClass("active");
    targetMenulist.slideUp().removeClass("active");
  } else {
    $(".js-menu").removeClass("active");
    $(".js-menu").find(".menu-list").slideUp().removeClass("active");

    target.addClass("active");
    targetMenulist.slideDown().addClass("active");
  }
});

// メニュー開閉
const toggleMenu = () => {
  $("#menu-trigger").on("click", (event) => {
    // メニューをトグル
    const menuObject = $("#menu-trigger");
    const menuListObject = $("#menu");
    // ハンバーガーメニュー切り替え
    menuObject.toggleClass("on");

    if (menuObject.hasClass("on")) {
      // bodyをfixed前に、メニューバーを開いた瞬間のスクロール位置を変数に保存
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      sessionStorage.setItem("scrollTopMenu", scrollTop);

      // position: fixed;でbodyのスクロールを禁止。スクロール位置もそのままで固定
      $("body").css({ position: "fixed", top: -scrollTop });

      // スクロール位置をセット
      $("body, html").scrollTop(scrollTop);
      // menuListObject.fadeToggle();
      menuListObject.toggleClass("on");

      $("body").append('<div id="overlay" class="overlay"></div>');

      $("#overlay").on("click", () => {
        $("body").css({ position: "static", top: 0 });
        menuObject.toggleClass("on");
        // menuListObject.fadeToggle();
        menuListObject.toggleClass("on");

        // オーバーレイを削除
        $("#overlay").remove();
      });
    } else {
      // もとに戻す
      $("body").css({ position: "static", top: 0 });
      // スクロール位置をセット
      $("body, html").scrollTop(sessionStorage.getItem("scrollTopMenu"));
      // menuListObject.fadeToggle();
      menuListObject.toggleClass("on");

      // オーバーレイを削除
      $("#overlay").remove();
    }
  });
};

const pageTop = () => {
  $("#pageTop").on("click", () => {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    );
    return false;
  });
};

/**
 * トップへ戻るボタンの表示切り替え
 */
const switchTopPage = () => {
  var $gotop = $("#pageTop");
  if (isMobile() == false) {
    if ($(window).scrollTop() > 400) {
      $gotop.fadeIn(200);
      $gotop.css("display", "flex");
    } else {
      $gotop.fadeOut(100);
    }
  } else {
    if ($(window).scrollTop() > 600) {
      $gotop.fadeIn(0);
      $gotop.css("display", "flex");
    } else {
      $gotop.fadeOut(0);
    }
  }
};

window.addEventListener(
  "scroll",
  () => {
    switchTopPage();
  },
  false
);

/**
 * スワイパー生成
 */
// var createSwiper = function (selector, options) {
//   return new Swiper(selector, options);
// };

/**
 * スワイパーオプション
 */
// var swiperOption = {
//   nextButton: ".swiper-button-next",
//   prevButton: ".swiper-button-prev",
//   pagination: ".swiper-pagination",
//   speed: 600,
//   spaceBetween: 0,
//   longSwipesRatio: 0.4,
//   loop: true,
//   autoplay: 3000,
// };

// {
//   pageTop();
//   toggleMenu();

//   // スワイパーを生成
//   createSwiper(".swiper", swiperOption);
// }
